module.exports = __webpack_public_path__ + "b6305bb407cfb829da7e7edded6325a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/x_corp_2023_chart.png
// module id = 1755
// module chunks = 0